var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page-content']},[_c('h2',{class:_vm.title},[_vm._v("Cookie Policy")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page)}}),_vm._v(" "),_c('vue-adsense',{attrs:{"ad-severity":"block","ad-client":_vm.adClient,"ad-slot":"8182071534","ad-format":"fluid","ad-layout":"in-article"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-370ba044","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cookies.vue
// module id = null
// module chunks = 